import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import ImgHeaderTitleEn from './images/title-en.webp'
import ImgHeaderTitleAr from './images/title-ar.webp'
import ImgAvatarFrameThis from './images/avatar-frame-this.webp'
import ImgAvatarFrameLast from './images/avatar-frame-last.webp'

import TabButtons from '@/components/TabButtons';
import Rewards from './components/Rewards';
import Rule from './components/Rule';
import Rank from './components/Rank';
import { getRank, getRewardsPool } from './services'
import { toast } from '@/utils/bridge'
import { useDesign } from '@/hooks'
import Loading from '@/components/Loading'
import './index.scss'

const { prefixCls } = useDesign('pg-room-rewards-day')

function RoomRewards() {
    const { t, i18n } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [state, setState] = useState<{
        selectedTab: number
        rewardsPool?: RoomRewards.RewardsPool
    }>({
        selectedTab: 0
    })
    const refState = useRef(state)
    refState.current = state

    const [rankList, setRankList] = useState<RoomRewards.RankItem[]>([])

    const tabsTitles = useMemo(() => {
        return ['RoomRewards.Today', 'RoomRewards.Yesterday', 'RoomRewards.RewardRule']
    }, [])

    const seconds = useMemo(() => {
        return state.rewardsPool?.endTime ? Number(((state.rewardsPool.endTime - Date.now()) / 1000).toFixed(0)) : 0
    }, [state.rewardsPool?.endTime])

    const fetchGetRewardsPool = useCallback(async () => {
        const res = await getRewardsPool()
        if (!res) return
        if (res.code !== 200) {
            toast(res.message)
            return
        }

        setState({
            ...refState.current,
            rewardsPool: res.data || {},
        })
    }, [])

    const fetchRankList = useCallback(async (type: number) => {
        setLoading(true)
        const res = await getRank(type === 1 ? 0 : 1)
        setLoading(false)
        if (!res) return
        const { code, data, message } = res
        if (code !== 200) {
            toast(message)
            return
        }
        if (!data) return

        setRankList(data.rankList)
    }, [])

    const handleTabChange = useCallback((i: number) => {
        setState({
            ...refState.current,
            selectedTab: i
        })
    }, [])

    useEffect(() => {
        fetchGetRewardsPool()
    }, [])

    useEffect(() => {
        fetchRankList(state.selectedTab)
    }, [state.selectedTab])

    return (
        <div className={clsx(prefixCls)}>
            {loading && <Loading />}
            <header className={`${prefixCls}__header`}>
                <img
                    className={`${prefixCls}__header-title`}
                    src={i18n.language === 'ar' ? ImgHeaderTitleAr : ImgHeaderTitleEn}
                />
                <div className={`${prefixCls}__header-agency`}>
                    <div className={`${prefixCls}__header-agency-img`}>
                        <img
                            className={`${prefixCls}__header-agency-frame`}
                            src={state.selectedTab === 1 ? ImgAvatarFrameLast : ImgAvatarFrameThis}
                        />
                        <img
                            className={`${prefixCls}__header-agency-avatar`}
                            src={rankList[0]?.avatar || ''}
                        />
                    </div>
                    {/* <div className={`${prefixCls}__header-agency-name`}>
                        {rankList[0]?.roomName || '--'}
                    </div> */}
                </div>
            </header>
            {/* <RewardsPool propRewardList={state.rewardsPool?.propRewardList || []} /> */}
            <TabButtons selectedTab={state.selectedTab} setSelectedTab={handleTabChange} tabText={tabsTitles}>
                {state.selectedTab === 0 &&
                    <div className={`${prefixCls}__container`}>
                        <span className={`${prefixCls}__container-title`}>{t('RoomRewards.CurrentRank')}</span>
                        <Rank selectedTab={state.selectedTab} seconds={seconds} rankList={rankList} />
                    </div>
                }
                {state.selectedTab === 1 &&
                    <div className={`${prefixCls}__container`}>
                        <span className={`${prefixCls}__container-title`}>{t('RoomRewards.YesterdayRank')}</span>
                        <Rank selectedTab={state.selectedTab} rankList={rankList} />
                    </div>
                }
                {state.selectedTab === 2 &&
                    <div >
                        <div className={clsx(`${prefixCls}__container`)}>
                            <span className={`${prefixCls}__container-title`}>{t('RoomRewards.RankRewards')}</span>
                            <Rewards />
                        </div>
                        {state.rewardsPool && <div className={clsx(`${prefixCls}__container`)}>
                            <span className={`${prefixCls}__container-title`}>{t('Common.ActiveRule')}</span>
                            <Rule activityThresholdValue={state.rewardsPool.activityThresholdValue} />
                        </div>}
                    </div>
                }
            </TabButtons>
        </div >
    )
}
export default RoomRewards